import { TextField } from '@statsbomb/kitbag-components';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const NameInput = ({
  id,
  value,
  onChange,
  errorMessage,
  autoFocus = false,
}: {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  autoFocus?: boolean;
}) => {
  const { t } = useTranslation('input');

  // auto selects the whole text within the input when rendered - This method ensures it also works when used within modals.
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (!autoFocus) return undefined;

    const timer = setTimeout(() => {
      inputRef.current?.select();
    }, 0);

    return () => clearTimeout(timer);
  }, [autoFocus]);

  return (
    <TextField
      ref={inputRef}
      id={id}
      label={t('name.label')}
      labelPosition="top"
      onChange={onChange}
      value={value}
      errorMessage={errorMessage}
    />
  );
};
